<template>
  <div>
    <Head />
    <div class="wrap" :class="{miniWrap: platform}">
      <div class="banner"></div>

      <div class="friends">
        <div class="headBar">饷店四大特色</div>
        <ul class="friend-items">
          <li>
            <div class="img"></div>
            <h3>正品大牌</h3>
            <p>海量正品货源</p>
            <p>精选优质好货</p>
          </li>
          <li>
            <div class="img"></div>
            <h3>超高性价比</h3>
            <p>品牌清仓特卖</p>
            <p>天天折上折</p>
          </li>
          <li>
            <div class="img"></div>
            <h3>直播购物</h3>
            <p>实时互动</p>
            <p>好物看得见</p>
          </li>
          <li>
            <div class="img"></div>
            <h3>管家式服务</h3>
            <p>专属店主服务</p>
            <p>便捷、贴心、诚信</p>
          </li>
        </ul>
      </div>

      <div class="servers">
        <div class="headBar">我们提供的服务</div>
        <div class="servers-items">
          <div class="item-wrap">
            <div class="line">
              <div>
                <img src="../common/img/serve1.png">
                <p>个性化店铺设置</p>
              </div>
              <div>
                <img src="../common/img/serve2.png">
                <p>自主选品自主上架</p>
              </div>
              <div>
                <img src="../common/img/serve3.png">
                <p>消费者自助下单</p>
              </div>
              <div>
                <img src="../common/img/serve4.png">
                <p>智能化营销工具</p>
              </div>
            </div>
            <div class="line">
              <div>
                <img src="../common/img/serve5.png">
                <p>云客服实时服务</p>
              </div>
              <div>
                <img src="../common/img/serve6.png">
                <p>店铺业绩数据分析</p>
              </div>
              <div>
                <img src="../common/img/serve7.png">
                <p>一件代发售后无忧</p>
              </div>
              <div>
                <img src="../common/img/serve8.png">
                <p>官方培训社群支持</p>
              </div>
            </div>
          </div>
          <!-- <div class="pay-wrap">
            <div class="pay-mn">&yen;<span>398</span>/年</div>
            <div class="pay-btn" @click="buyNow">立即购买</div>
          </div> -->
        </div>
      </div>
      <!-- <img class="service-entrance"
         src="../common/img/service-entrance.png"
         @click="onService" />
      <Service ref="service" /> -->
      <div class="ruless">
        <div class="headBar">常见问题</div>
        <ul class="friend-items">
          <li>
            <div class="msg">
              <p class="name">1.店主如何为消费者服务？</p>
              <p class="age">消费者可通过“饷店”小程序，购买高性价比的品牌商品，并享受店主提供的包括选品、荐品、售后在内的管家式购物服务。</p>
            </div>
          </li>
          <li>
            <div class="msg">
              <p class="name">2.如何处理售后问题？</p>
              <p class="age">进入店铺我的订单页面找到该笔订单。未发货订单，可以直接申请退款。已发货订单，可点击【申请售后】退货，退款会原路退回。</p>
            </div>
          </li>
          <li>
            <div class="msg">
              <p class="name">3.发货时效和物流如何查询？</p>
              <p class="age">活动结束（2-3天）后开始发货店主可进入订单详情查看物流情况。消费者需重新通过链接或者是扫描二维码的方式，进入店铺，查看订单物流信息。</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="openedTip" v-show="showOpenTip">你已开通饷店，自动为你跳转店主后台...</div>
    </div>
    <Foot />
    <Login v-show="showLogin" />
    <LoginOut v-show="showLoginOut" />
  </div>
</template>

<script>
import Head from 'components/header'
import Foot from 'components/footer'
import Login from 'components/login'
// import Service from 'components/service'
import LoginOut from 'components/loginout'
import { mapState, mapMutations } from 'vuex'
import { xdHasShop } from 'api/http'
export default {
  data() {
    return {
      showOpenTip: false
    }
  },
  created() {
    this.setName(4)
    this.setPlatform()

    this.$track.sendLog('pageview', {
      spm: '3.1602'
    })
  },
  mounted() {
    window.scrollTo(0, 800)
  },
  components: {
    Head,
    Foot,
    Login,
    LoginOut
  },
  computed: {
    ...mapState([
      'platform',
      'userInfo',
      'showLogin',
      'showLoginOut',
      'price'
    ])
  },
  methods: {
    ...mapMutations(['setName', 'setPlatform', 'setLoginWrap']),
    async buyNow() {
      this.$track.sendLog('click', {
        spm: '3.1602.1796'
      })

      // 开通了饷店（购买的饷店在有效期内）、跳转到饷团官网 ----2019-09-28新增逻辑by 陈小飞
      let phone = this.userInfo.userPhone || ''
      let opened = await xdHasShop({mobile: phone}).catch(er=> {
        console.log('xdSms', er)
      })
      if(opened.success && opened.data) {
        let redirectUri = process.env.NODE_ENV == 'production' ? 'https://console.xiangtuan.xyz/login?loginType=msg' : 'http://msbackend-test1.akucun.com/login?loginType=msg'
        this.showOpenTip = true
        setTimeout(()=> {
          this.showOpenTip = false
          window.location.href = redirectUri
        }, 1500)
        return
      }

      if(this.userInfo.userId) {
        this.$router.push('/paycenter')
      }else {
        this.setLoginWrap(true)
      }
    },
    onService(){
     let token = localStorage.getItem('akc_token')
      let akid = localStorage.getItem('akc_akid')
      let vipLevel = localStorage.getItem('akc_vip_level')
      if (!token || !akid || !vipLevel) {
        this.setLoginWrap(true)
        return
      }
      this.$refs.service.show(token, akid, vipLevel)
    }    
  }
}
</script>

<style scoped lang="less">
  .wrap {
    width: 100%;
    background: #fff;
    .service-entrance {
      width: 90px;
      height: 100px;
      position: fixed;
      bottom: 60px;
      right: 0;
    }
    .banner {
      width: 100%;
      padding-bottom: 36%;
      background-image: url('../common/img/new/shop-banner.jpg');
      background-size: 100% 100%;
    }
    .friends {
      .headBar {
        font-size:36px;
        font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight:800;
        color:#333;
        line-height:50px;
        padding: 79px 0 53px 0;
      }
      .friend-items {
        height: 250px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        li {
          height: 100%;
          width: 230px;
          padding: 40px 0;
          background: #F7F7F7;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          position: relative;
          .img {
            height: 72px;
            width: 72px;
            background-size: 100% 100%;
          }
          h3 {
            font-size:20px;
            font-family:PingFangSC-Medium,PingFang SC,PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
            font-weight:600;
            color:#333;
            line-height:28px;
            margin: 21px 0 10px;
          }
          p {
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:#666;
            line-height:20px;
          }
          &:first-child .img {
            background-image: url('../common/img/new/feature1.png');
          }
          &:nth-child(2) .img {
            background-image: url('../common/img/new/feature2.png');
          }
          &:nth-child(3) .img {
            background-image: url('../common/img/new/feature3.png');
          }
          &:last-child .img{
            background-image: url('../common/img/new/feature4.png');
          }
        }
      }
    }
    .servers {
      .headBar {
        font-size: 36px;
        font-family: PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight: 800;
        color: #333;
        line-height: 50px;
        padding: 82px 0 56px 0;
      }
      .servers-items {
        width: 100%;
        height: 315px;
        padding: 42px 0;
        border: solid 1px #E6E6E6;
        display: flex;
        flex-direction: row;
        .item-wrap {
          // width: 787px;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .line {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            div {
              width: 25%;
            }
            p {
              font-size: 13px;
              font-family: PingFangSC-Regular, sans-serif;
              color: rgba(51,51,51,1);
              line-height: 18px;
              margin-top: 10px;
            }
            img {
              width: 60px;
              height: 60px;
            }
          }
        }
        .pay-wrap {
          width: 211px;
          background: #FAFAFA;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .pay-mn {
            color: #EC2232;
            font-size: 16px;
            font-family: PingFangSC-Regular, sans-serif;
            line-height: 22px;
            span {
              font-family: DIN;
              font-weight: bold;
              font-size: 44px;
              line-height: 54px;
            }
          }
          .pay-btn {
            width: 110px;
            height: 34px;
            background: linear-gradient(135deg,rgba(255,84,84,1) 0%,rgba(236,34,50,1) 100%);
            border-radius: 2px;
            font-size: 16px;
            line-height: 34px;
            color: #fff;
            margin-top: 20px;
            cursor: pointer;
          }
        }
      }
    }

    .ruless {
      padding: 0 0 60px 0;
      .headBar {
        font-size:36px;
        font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight:800;
        color:#333;
        line-height:50px;
        padding: 82px 0 53px;
      }
      .friend-items {
        height: 172px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        li {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          width: 300px;
          height: 100%;
          text-align: left;
          background: #F7F7F7;
          padding: 20px;
          .msg {
            position: relative;
            p.name {
              font-size:15px;
              font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
              font-weight:800;
              color:#333;
              line-height:21px;
            }
            p.age {
              font-size:13px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:#333;
              line-height:22px;
              position: absolute;
              top: 36px;
              left: 0;
            }
          }
        }
      }
    }
  }
  .openedTip {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background: rgba(0, 0, 0, .6);
    border-radius: 3px;
    color: #fff;
    font-size: 12px;
    width: 252px;
    line-height: 32px;
  }
</style>
